import React from 'react';
import { trackData, trackDataV2 } from '../../logic/analytics';

const TrackerContext = React.createContext();

function TrackerProvider(props) {
    function checkAndUpdateSession(action) {
        const SESSION_KEY = "__user_session__";
        const REVIEW_KEY = "__user_has_reviewed__";
        const SESSION_TIMEOUT = 3600000;
        const now = Date.now();

        if (action === "usersession") {
            let lastSession = localStorage.getItem(SESSION_KEY);

            if (lastSession) {
                lastSession = parseInt(lastSession, 10);

                if (Math.abs(lastSession - now) <= SESSION_TIMEOUT) {
                    localStorage.setItem(SESSION_KEY, now.toString());
                    return false;
                }
            }
        }

        localStorage.setItem(SESSION_KEY, now.toString());
        localStorage.removeItem(REVIEW_KEY);
        return true;
    }

    async function trackDataFn(id, token, action, metadata, hasOrders) {

        await trackData(id, action, metadata);

        const shouldTrack = checkAndUpdateSession(action);
        if (shouldTrack) {
            await trackDataV2(id, token, action, metadata, hasOrders);
        }
    }

    const value = {
        trackDataFn,
    };

    return <TrackerContext.Provider value={value} {...props}></TrackerContext.Provider>;
}

function useTracker() {
    let context = React.useContext(TrackerContext);
    if (!context) {
        throw new Error("useTracker must be used within a TrackerProvider");
    }
    return context;
}

export {
    TrackerProvider,
    useTracker,
};
